

export const numberToMoney = (numb = 0) => {
  let number = numb
  if (number === null) {
    number = 0
  }
  return `Rp. ${(typeof number === 'string' ? parseInt(number.replace('.00', ''), 10) : number).toLocaleString().replace(/,/g, '.')}`
}
export const numberToMoneyNoRP = (number = 0) => `${number.toLocaleString().replace(/,/g, '.')}`
export const numberToMoneyWithoutPrefix = (number = 0) => `${number.toLocaleString().replace(/,/g, '.')}`
export const moneyToNumber = (money = '0') => parseInt(money.replace(/\./g, '').replace('Rp', '').trim(), 10)



// WEBPACK FOOTER //
// src/utils/formatter/currency/index.js